import { memo } from 'react'

import { Text } from '~/shared/ui/Text'
import { VStack } from '~/shared/ui/VStack'

import type { FieldProps } from './types'

/**
 * Обёртка «лейбл + контрол + подпись/ошибка» вокруг произвольного слота (§24-25).
 *
 * Для полей-кнопок (дата/время/город), где подпись должна стоять по центру пустого поля
 * и уезжать наверх при выборе, нужен не `Field`, а `ValueField` — там подпись живёт
 * внутри самого поля.
 */
export const Field = memo(function Field(props: FieldProps) {
  const { label, labelColor = 'MUTED', hint, errorText, hasError = false, children } = props

  const bottomText = hasError && errorText ? errorText : hint

  return (
    <VStack gap='SMALL_S'>
      {label && (
        <Text variant='OVERLINE' color={labelColor === 'ACCENT' ? 'ACCENT' : 'MUTED'}>
          {label}
        </Text>
      )}
      {children}
      {bottomText && (
        <Text variant='CAPTION' color={hasError ? 'ERROR_TEXT' : 'DIM'}>
          {bottomText}
        </Text>
      )}
    </VStack>
  )
})
